import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDynamicCriteriaHost]',
})
export class CriteriaHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
